import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const partnerCarInsuranceLandingRoutes = [
  {
    /**
     * Route for "Bankrate" landing page
     * https://www.edmunds.com/partner-insurance/
     */
    path: '/partner-insurance',
    exact: true,
    page: getLoadablePage(
      () =>
        import(
          /* webpackChunkName: "partner-car-insurance-landing" */ 'site-modules/brand-landing/pages/partner-car-insurance-landing/partner-car-insurance-landing-definition'
        )
    ),
    chunkName: 'partner-car-insurance-landing',
    enableLooseEtag: true,
  },
];
